import React, { useEffect, useRef, useState, useCallback } from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useStore } from "./src/store/UserStore";
import * as ImSdk from "./imsdk/api";
import { FullProcessData, MQEventCallBack } from "./imsdk/api/mq";
import log from "./imsdk/log";
import { AuthStack } from "./src/screen/navigation/auth/AuthStack";
import { TopicWithSummary } from "./imsdk/api/topic";
import { AppState, AppStateStatus, Platform, View, Text, ActivityIndicator } from "react-native";
import cache from "./src/cache";
import {
  getUid,
  getToken,
  getVcode,
  setEncrypt,
  setMsgAssistant,
  setMsgTranslate,
  setOs,
  setSecret,
  setServiceUrl,
  setToken,
  setUid,
  setVcode,
} from "./src/store/token";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  GetContactList,
  qryContactBlackList,
  TopicSummaryStat,
} from "./src/store/utils";
import { setInitialLanguage } from "./src/language/i18n";
import { defKKAuth, KKAuth } from "./imsdk/api";
import { useAppNavigation } from "./src/screen/navigation";
import NetInfo from "@react-native-community/netinfo";
import { buildSignalTopicId } from "./src/utils/utils";
import { useSwitchAccStore } from "./src/store/SwitchAccStore";
import { JPushManager } from "./src/utils/JPushManager";
import { DeviceEventEmitter } from "react-native";
import { attachConfig, reportRegistrationID } from "./src/net/service";
import { clearUnreadIfCurrentTopic } from "./src/screen/Chat/chat-helper";
import { MainRootStack } from "./src/screen/navigation/main/MainRootStack";
import { SplashScreen } from "./src/screen/login/SplashScreen";
import { color_main, color_666666 } from "./src/assets/style/colors";
// FeatureScreen removed for web
import globalEventBus from "./src/utils/EventBus";
import { RTCEngine } from "./src/utils/RTCEngine";
import DeviceInfo from "react-native-device-info";
import { showDialog } from "./src/components/CommonDialog";
import { Str_Confirm, Str_HadCancelAuthorize, Str_HadChangeAccount, Str_Tip } from "./src/language/string_res";
import { readPersistedMac } from "./src/screen/login/QRCodeLogin";
import { TenantSettings } from "./imsdk/db/t_user_devices";
import { Auth } from "./imsdk/db/t_auth";
export const NetConnected = {
  isConnected: true,
};

export const setIgnoreAuthFail = async () => {
  await AsyncStorage.setItem("ignore_auth_fail", "1");
}
export const setNotIgnoreAuthFail = async () => {
  setTimeout(() => {
    AsyncStorage.setItem("ignore_auth_fail", "0");
  }, 4000);
}

export const getIgnoreAuthFail = async (): Promise<boolean> => {
  const value = await AsyncStorage.getItem("ignore_auth_fail");
  return value === "1";
}



// 内层组件：在 NavigationContainer 内部，可以使用 navigation hook
function AppContent(): React.JSX.Element {
  const im = ImSdk.getInstance();

  const { dispatch } = useStore();

  const { switchState } = useSwitchAccStore();

  const topics = useRef<TopicSummaryStat>();
  const navigation = useAppNavigation();
  // 上一次Token过期处理的时间戳
  const authFailHandleTime = useRef(0);
  const isHadShowAuthorizeExpireDialogRef = useRef(false)

  /** sync 每轮完成后通知 MainTab 关闭「同步中」loading（与 049f005 对齐） */
  const syncDoneCallback = useCallback(() => {
    globalEventBus.emit("on_refresh", { name: "done" });
  }, []);
  
  // Web 环境下，用于管理初始化完成后的导航
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setOs("web");
    setInitialLanguage().then();
    const unsubscribe = NetInfo.addEventListener((lis) => {
      if (lis.isConnected !== undefined && lis.isConnected !== null) {
        NetConnected.isConnected = lis.isConnected;
      }
    });
    return () => {
      unsubscribe();
    };
  }, []);
  useEffect(() => {
    if (switchState.dataVersion > 0) {
      regEvent();
    }
  }, [switchState?.dataVersion]);

  useEffect(() => {
    const appStateChange = (nextStat: AppStateStatus) => {
      if (nextStat === "active") {
        void im.updateAttachConfig();
        globalEventBus.emit("on_refresh", { name: "sync_start" });
      }
      if (nextStat === "background") {
        try {
          const topicSummaryList = im.GetCache(
            `${im.CurrentUid()}_topic_list`
          ) as {
            top: TopicWithSummary[];
            normal: TopicWithSummary[];
          };
          if (topicSummaryList) {
            const topCnt = topicSummaryList.top.length;
            const normalCnt = topicSummaryList.normal.length;
            AsyncStorage.setItem(
              `${im.CurrentUid()}_topic_list`,
              JSON.stringify(topicSummaryList)
            )
              .then(() => {
                console.log(
                  "====应用退到后台前保存会话数据成功",
                  topCnt,
                  normalCnt
                );
              })
              .catch((err) => {
                // 应用退到后台前保存会话数据失败
              });
          }
        } catch (e) {
          // 应用退到后台前保存会话数据异常
        }
      }
    };

    AppState.addEventListener("change", appStateChange);

    im.global_on("global_login", globalCallback);
    im.global_on("global_logout", globalCallback);
    // FeatureScreen listener removed

    // Web 平台直接初始化，不需要延迟
    if (Platform.OS === "web") {
      im.init()
        .then(async (res) => {
          if (res.error) {
            console.error("❌ [App] 初始化IMSDK失败", res.error);
            log.error("初始化IMSDK失败", res.error);
            // 初始化失败，导航到登录页
            setIsInitialized(true);
            navigation.reset({ index: 0, routes: [{ name: "AuthStack" }] });
            return;
          }
          log.info("IMSDK成功");
          const auth = await im.GetLastAuth();
          log.info("上一次的登陆信息:", auth);
          if (auth.uid > 0 && auth.token) {
            GetCacheTopic(auth.uid);
            setIsInitialized(true);
            await SwitchUser(auth);
          } else {
            setIsInitialized(true);
            navigation.reset({ index: 0, routes: [{ name: "AuthStack" }] });
          }
        })
        .catch((error) => {
          console.error("❌ [App] IMSDK 初始化异常:", error);
          // 异常时默认进入登录页
          setIsInitialized(true);
          navigation.reset({ index: 0, routes: [{ name: "AuthStack" }] });
        });
    } else {
      init();
    }

    return () => {
      // AppState.removeEventListener('change', appStateChange);
      im.global_off("*", globalCallback);
      im.off("*", userCallback);
      im.off("*", topicCallback);
      im.off("rtc_msg", rtcCallback);
      im.off("friend_apply", friendCallback);
      im.off("*", msgCallback);
      im.off("*", userChangeCallback);
      im.off("*", syncCallback);
      im.off("sync_loop_done", syncDoneCallback);
      // push.setUpdateListener(null);
    };
  }, []);

  const init = () => {
    im.init()
      .then(async (res) => {
        if (res.error) {
          console.error("❌ [App] 初始化IMSDK失败", res.error);
          log.error("初始化IMSDK失败", res.error);
          return;
        }
        log.info("IMSDK成功");
        const auth = await im.GetLastAuth();
        log.info("上一次的登陆信息:", auth);
        AsyncStorage.getItem(`${auth.uid}-LoginGuide`).then((res) => {
          dispatch({ type: "SET_LOGIN_GUIDE", payload: res === "1" });
        });
        if (auth.uid > 0 && auth.token) {
          GetCacheTopic(auth.uid);
          await SwitchUser(auth);
        } else {
          navigation.reset({ index: 0, routes: [{ name: "AuthStack" }] });
        }
      })
      .catch((error) => {
        console.error("❌ [App] IMSDK 初始化异常:", error);
      });
  };

  const refreshFunc = (): Promise<void> => {
    console.log('🔄 [App] refreshFunc() 开始加载会话列表');
    return new Promise((resolve) => {
      // isEmit 固定 false：REPLACE_TOPIC_SUMMARY_LIST 会整体替换列表，不需要逐条 emit topic_qry
      im.GetAllTopicList(false, false).then((res) => {
        const { isAllRefresh, topTopics, normalTopics } = res;
        if (isAllRefresh) {
          const topicSummary = {
            top: topTopics || [],
            normal: normalTopics || [],
          };
          im.SetCache(`${im.CurrentUid()}_topic_list`, topicSummary);
          dispatch({
            type: "REPLACE_TOPIC_SUMMARY_LIST",
            payload: topicSummary,
          });
        }
        // 发事件通知到 ChatScreen
        cache.Set("justSwitchedAccount", true);
        DeviceEventEmitter.emit("topic_list_ready");
        resolve();
      }).catch((err) => {
        console.error('❌ [App] GetAllTopicList 失败:', err);
        resolve();
      });
    });
  };

  const userCallback: MQEventCallBack = async (res) => {
    if (res.type === "auth_fail") {
      log.warn("auth_fail 回调", JSON.stringify(res));
      const arrowSwitchUser = await AsyncStorage.getItem("arrow_switch_user");
      await AsyncStorage.setItem("arrow_switch_user", "");

      const curTime = new Date().getTime();
      if (curTime - authFailHandleTime.current <= 5 * 1000) {
        // 最少间隔5秒才处理一次
        return;
      }

      // 如果登录页面标记了忽略授权过期（如正在登录流程中），则本次遇到 auth_fail 不处理，继续忽略，并重置标记
      const isIgnore = await getIgnoreAuthFail();
      if (isIgnore) {
        return;
      }

      authFailHandleTime.current = curTime;

      if (arrowSwitchUser && arrowSwitchUser.length > 0) {
        log.info("检测到连续两次Token过期，尝试切换到下一个账号", res);
        const authsResult = await im.getAuths();
        if (authsResult.error === undefined && authsResult.auths && authsResult.auths.length) {
          const nextAuths = authsResult.auths.filter(auth => auth.uid.toString() !== arrowSwitchUser);
          if (nextAuths.length > 0) {
            await SwitchUser(nextAuths[0], false, 0);
            return;
          }
        }
      }

      log.info("被动退出", res);
      dispatch({
        type: "REPLACE_TOPIC_SUMMARY_LIST",
        payload: { top: [], normal: [] },
      });
      JPushManager.removeAlias();
      await im.SwitchUser(defKKAuth);

      const vcode = res.data.auth_fail?.vcode;
      const msg = res.data.auth_fail?.msg;
      resetAuthStack({ vcode: vcode, msg: msg })
    }
  };

  const resetAuthStack = async (params: any) => {
    const index = navigation.getState().index
    const routes = navigation.getState()?.routes
    let name
    if (routes && index !== -1) {
      name = routes[index].name
    }
    
    if (name === 'AuthStack') {
      return
    }

    let routesParams: any = undefined
    const vcode = params.vcode || getVcode()
    // 暂时不到登录页面了, 先注释掉 vcode 相关逻辑
    if (vcode.length > 0) {
      routesParams = { ...params, vcode: vcode, screen: 'Login' }
    }

    navigation.reset({
      index: 0,
      routes: [{
        name: 'AuthStack',
        params: routesParams
      }]
    })

    if (isHadShowAuthorizeExpireDialogRef.current === true) {
      return;
    }


    const msg = params.msg;
    console.log("resetAuthStack params", params);
    if (msg && msg.length > 0) {
      isHadShowAuthorizeExpireDialogRef.current = true;
      setTimeout(() => {
        // 显示消息
        showDialog({
          title: Str_Tip,
          message: msg,
          confirmText: Str_Confirm,
          outDismiss: false,
          onConfirm: () => {
            isHadShowAuthorizeExpireDialogRef.current = false;
            // 点击确定后的操作（如切换账号等）
          }
        })
      }, 500);
    }
  }

  function refreshContact() {
    console.log('🔄 [App] refreshContact() 开始加载联系人列表');
    ImSdk.getInstance().GetRemoteContact().then((res1) => {
      console.log('✅ [App] GetRemoteContact 返回:', {
        error: res1.error,
        userCount: res1.users?.length || 0
      });
      const contacts = res1.users ?? [];
      ImSdk.getInstance().GetRemoteFriendBlack().then((res2) => {
        console.log('✅ [App] GetRemoteFriendBlack 返回:', {
          error: res2.error,
          blackCount: res2.blacks?.length || 0
        });
        const blacks = res2.blacks ?? [];
        console.log('💾 [App] 保存联系人列表到 store, contacts:', contacts.length, 'blacks:', blacks.length);
        dispatch({
          type: "REPLACE_CONTACT_LIST",
          payload: { users: contacts, black: blacks },
        });
      }).catch((err) => {
        console.error('❌ [App] GetRemoteFriendBlack 失败:', err);
      });

      ImSdk.getInstance().GetLabelsRemote(0, 10000).then().catch((err) => {
        console.error('❌ [App] GetLabelsRemote 失败:', err);
      });
    }).catch((err) => {
      console.error('❌ [App] GetRemoteContact 失败:', err);
    });
  }

  const syncCallback: MQEventCallBack = async (res) => {
    if (res.type === "contact_refresh") {
      refreshContact();
      return;
    }
  };
  const msgCallback: MQEventCallBack = async (res) => {
    // log.info("====处理会话变更事件", JSON.stringify(res));

    if (res.type === "msg_update" && res.data.msg_update) {
      // 查询具体某条消息, 如果这个消息是会话的latest则更新状态
      const r = await im.GetTopicDetail(res.data.msg_update.tid);
      if (r.topic) {
        const maxmid = r.topic.summary?.latest?.mid || "";
        if (res.data.msg_update.mid >= maxmid) {
          dispatch({
            type: "UPSERT_TOPIC_SUMMARY",
            payload: [clearUnreadIfCurrentTopic(r.topic)],
          });
        }
      }
    }
  };

  const notifyCallback: MQEventCallBack = async (res) => {
    if (res.type === "open_notify" && res.data.open_notify) {
      dispatch({
        type: "Notify",
        payload: res.data.open_notify.msg,
      });
    }
  };
  const topicCallback: MQEventCallBack = async (res) => {
    // log.info("=====处理会话变更事件", res.type);
    if (res.type === "topic_batch_written" && res.data.topic_batch_written) {
      const tids: string[] = res.data.topic_batch_written.tids || [];
      if (tids.length > 0) {
        const items: TopicWithSummary[] = [];
        for (const tid of tids) {
          const r = await im.GetTopicDetail(tid, true, false);
          if (r.topic) {
            items.push(clearUnreadIfCurrentTopic(r.topic));
          }
        }
        if (items.length > 0) {
          dispatch({
            type: "UPSERT_TOPIC_SUMMARY",
            payload: items,
          });
        }
      }
      return;
    }
    if (res.type === "topic_refresh") {
      refreshFunc();
      return;
    }
    if (res.type === "topic_qry" && res.data.topic_qry) {
      dispatch({
        type: "UPSERT_TOPIC_SUMMARY",
        payload: [clearUnreadIfCurrentTopic(res.data.topic_qry.topicDetail)],
      });
      return;
    }
    if (res.type === "topic_update_draft" && res.data.topic_update_draft) {
      dispatch({
        type: "UPDATE_TOPIC_DRAFT",
        payload: res.data.topic_update_draft,
      });
      return;
    }
    let dispthType = "UPDATE_TOPIC_SUMMARY";
    const tids: string[] = [];
    if (
      res.type === "topic_new" &&
      res.data.topic_new?.tidList &&
      res.data.topic_new?.tidList.length > 0
    ) {
      tids.push(...res.data.topic_new.tidList);
      dispthType = "UPSERT_TOPIC_SUMMARY";
    }

    let tid: string = "";
    switch (res.type) {
      case "topic_to_top":
        tid = res.data.topic_to_top?.tid || "";
        const ord = res.data.topic_to_top?.order || 0;
        if (ord > 0) {
          dispthType = "UPSERT_TOPIC_SUMMARY";
        }
        break;
      case "topic_mute":
        tid = res.data.topic_mute?.tid || "";
        break;
      case "topic_visit":
        tid = res.data.topic_visit?.tid || "";
        dispthType = "UPSERT_TOPIC_SUMMARY";
        break;
      case "topic_update":
        tid = res.data.topic_update?.tid || "";
        break;
      case "topic_delete":
        tid = res.data.topic_delete?.tid || "";
        break;
      case "topic_remark":
        tid = res.data.topic_remark?.tid || "";
        break;
      case "msg_new":
        tid = res.data.msg_new?.tid || "";
        dispthType = "UPSERT_TOPIC_SUMMARY";
        break;
      case "msg_del":
        tid = res.data.msg_del?.tid || "";
        dispthType = "UPSERT_TOPIC_SUMMARY";
        break;
      case "group_update":
        tid = res.data.group_update?.tid || "";
        break;
      default:
        // log.warn('处理会话变更回调遇到未知的事件类型', res.type);
        break;
    }
    if (tid && tid.length > 0) {
      tids.push(tid);
    }

    // 获取会话详情，修改当前viewList数据
    const n = tids.length;
    const upitems: TopicWithSummary[] = [];
    for (let i = 0; i < n; i++) {
      const r = await im.GetTopicDetail(tids[i], true, false);
      if (r.error) {
        log.warn("GetTopicDetail", tids[i], "Error!", r.error);
        continue;
      }
      if (!r.topic) {
        log.info("GetTopicDetail", tids[i], "Local Empty");
        continue;
      }
      upitems.push(clearUnreadIfCurrentTopic(r.topic));
    }
    if (upitems.length > 0) {
      dispatch({
        // @ts-ignore
        type: dispthType,
        payload: upitems,
      });
    }
  };

  const friendCallback: MQEventCallBack = (res) => {
    if (res.type === "friend_apply") {
      log.info("添加好友请求", res);
      dispatch({
        type: "UPDATE_FRIEND_APPLY_NUM",
        payload: res.data.friend_apply?.count || 0,
      });
    }
  };
  const rtcCallback: MQEventCallBack = (res) => {
    if (res.type === "rtc_msg" && res.data.rtc_msg) {
      RTCEngine.callDisplay(res.data.rtc_msg);
    }
  };

  const updateCurAuth = (tenant_settings?: TenantSettings) => {
    if (tenant_settings) {
      tenant_settings.switch_regist = tenant_settings.switch_regist ?? 0
      tenant_settings.switch_tab_main = tenant_settings.switch_tab_main ?? 0
      tenant_settings.switch_tab_mine = tenant_settings.switch_tab_mine ?? 1 // 至少开启一个
      tenant_settings.switch_rtc = tenant_settings.switch_rtc ?? 0
      const curUid = getUid();

      im.getAuth(curUid).then((res) => {
        if (res.error || !res.auth) {
          log.warn("获取当前用户鉴权信息失败", res.error);
          return;
        }
        const auth = res.auth;
        const newAuth = {
          ...auth,
          ...tenant_settings
        } as KKAuth & Auth;
        im.insertAuth(newAuth);

        dispatch({
          type: 'UPDATE_TENANT_SETTINGS',
          payload: tenant_settings
        });
      })
    }
  }

  const userChangeCallback: MQEventCallBack = async (res) => {
    if (res.type === "tenant_settings") {
      const data = res.data.tenant_settings
      if (data && data.settings) {
        updateCurAuth(data.settings)
      }
      return
    }

    if (res.type === "user_devices") {
      if (res.data.user_devices) {
        dispatch({
          type: 'UPDATE_LOGIN_DEVICES',
          payload: res.data.user_devices.devices || []
        });

        const isIgnore = await getIgnoreAuthFail();
        if (isIgnore) {
          return
        }

        const d = res.data.user_devices.devices || [];
        type DeviceRow = { deviceId?: string; token?: string };
        const rows = d as DeviceRow[];
        const uniqueId = await DeviceInfo.getUniqueId().catch(() => "");
        let myDeviceId = uniqueId || "";
        if (Platform.OS === "web") {
          const mac = await readPersistedMac();
          if (mac) {
            const webId = mac.startsWith("web_") ? mac : `web_${mac}`;
            myDeviceId = myDeviceId || webId;
          }
        }
        const myToken = getToken();
        const isIncludeMine =
          (!!myDeviceId && rows.some((device) => device.deviceId === myDeviceId)) ||
          (!!myToken && rows.some((device) => device.token === myToken));
        if (myDeviceId || myToken) {
          if (!isIncludeMine) {
            log.warn(
              "user_devices：本机不在设备列表",
              "myDeviceId=",
              myDeviceId,
              "hasTokenMatch=",
              !!myToken && rows.some((device) => device.token === myToken),
            );
            const authsResult = await im.getAuths();
            let isMuteAccount = false
            if (authsResult.error === undefined && authsResult.auths && authsResult.auths.length) {
              const curUid = getUid();
              const nextAuths = authsResult.auths.filter(auth => auth.uid !== curUid);
              if (nextAuths.length > 0) {
                const curAuth = authsResult.auths.find(auth => auth.uid === curUid);
                isMuteAccount = true
                await im.delAuths(curAuth?.uid || 0);
                SwitchUser(nextAuths[0])
              } else {
                log.warn("user_devices：无其它账号可切，emit(auth_fail)");
                im.emit('auth_fail', { auth_fail: { vcode: getVcode(), msg: Str_HadCancelAuthorize } });
              }
            } else {
              log.warn("user_devices：getAuths 失败或无账号，emit(auth_fail)");
              im.emit('auth_fail', { auth_fail: { vcode: getVcode(), msg: Str_HadCancelAuthorize } });
            }

            const title = isMuteAccount ? Str_HadCancelAuthorize : undefined
            const message = isMuteAccount ? Str_HadChangeAccount : Str_HadCancelAuthorize
            setTimeout(() => {
              showDialog({
                title: title,
                message: message,
                confirmText: Str_Confirm,
                onConfirm: () => {
                },
              });
            }, 1000);
          }
        }
      }
      return
    }

    if (res.type === "user_black") {
      //黑名单操作
      dispatch({
        type: "UPDATE_CONTACT_BLACK_LIST",
        payload: res.data.user_black,
      });
      return;
    }
    if (res.type === "userinfo") {
      if (res.data.userinfo) {
        im.UpdateUser(res.data.userinfo).then();
        dispatch({ type: "UPDATE_CONTACT_LIST", payload: res.data.userinfo });
      }
      return;
    }

    if (res.type === "user_remark") {
      if (res.data.user_remark) {
        const data = res.data.user_remark;
        im.UpdateLabelRemark(data.uid, data.remark).then();
        const r = await im.QryGroupTidsByUid(data.uid);
        const stid = buildSignalTopicId(data.uid, im.CurrentUid());
        const topic = await im.GetTopicDetail(stid);
        const tids = r.tids || [];
        tids.push(stid);
        dispatch({ type: "UPDATE_CONTACT_REMARK", payload: { ...data, tids } });
        if (topic.topic) {
          dispatch({
            type: "UPSERT_TOPIC_SUMMARY",
            payload: [topic.topic],
          });
        }
      }
      return;
    }
    if (res.type === "user_head") {
      if (res.data.user_head) {
        const data = res.data.user_head;
        im.UpdateLabelRemark(data.uid, data.avatar).then();
        const r = await im.QryGroupTidsByUid(data.uid);
        const tids = r.tids || [];
        const stid = buildSignalTopicId(data.uid, im.CurrentUid());
        tids.push(stid);
        dispatch({ type: "UPDATE_CONTACT_AVATAR", payload: { ...data, tids } });
      }
      return;
    }
  };
  const userPermissionCallback: MQEventCallBack = async (res) => {
    if (res.type === "user_permission") {
      const data = res.data.user_permission;
      let count = 0;
      if (data && data.msgAssistant !== undefined) {
        setMsgAssistant(data.msgAssistant);
        count++;
      }

      if (data && data.msgTranslate !== undefined) {
        setMsgTranslate(data.msgTranslate);
        count++;
      }
      if (count > 0) {
        ImSdk.getInstance()
          .GetLastAuth()
          .then((auth) => {
            if (data && data.msgAssistant !== undefined) {
              auth.msgAssistant = data.msgAssistant;
            }

            if (data && data.msgTranslate !== undefined) {
              auth.msgTranslate = data.msgTranslate;
            }
            ImSdk.getInstance().SetLastAuth(auth);
          });
      }
    }
  };
  const regEvent = () => {
    im.off("sync_loop_done", syncDoneCallback);
    im.on("sync_loop_done", syncDoneCallback);
    im.on("open_notify", notifyCallback);
    im.on("topic_qry", topicCallback);
    im.on("group_update", topicCallback);
    im.on("topic_batch_written", topicCallback);
    im.on("topic_refresh", topicCallback);
    im.on("topic_mute", topicCallback);
    im.on("topic_new", topicCallback);
    im.on("topic_visit", topicCallback);
    im.on("topic_update", topicCallback);
    im.on("topic_update_draft", topicCallback);
    im.on("topic_to_top", topicCallback);
    im.on("topic_delete", topicCallback);
    im.on("topic_remark", topicCallback);
    im.on("msg_new", topicCallback);
    im.on("msg_del", topicCallback);
    im.on("friend_apply", friendCallback);
    im.on("msg_update", msgCallback);
    im.on("full_process", syncCallback);
    im.on("contact_refresh", syncCallback);
    im.on("user_black", userChangeCallback);
    im.on("user_head", userChangeCallback);
    im.on("userinfo", userChangeCallback);
    im.on("user_remark", userChangeCallback);
    im.on("user_devices", userChangeCallback);
    im.on("tenant_settings", userChangeCallback);
    im.on("user_permission", userPermissionCallback);
    im.on("rtc_msg", rtcCallback);
  };
  const globalCallback: MQEventCallBack = async (res) => {
    if (res.type === "global_logout") {
      log.info("用户主动登出", res);
      // push.ClearNotifications();
      im.ClearCache();
      cache.Clear();
      const vcode = res.data?.global_logout?.vcode ?? "";
      const screen = res.data?.global_logout?.screen;
      dispatch({ type: "LOGOUT" });
      JPushManager.removeAlias();
      await im.SwitchUser(defKKAuth);
      // setPage({page: "auth", vcode});
      let params = {}
      if (screen) {
        params = { screen: screen, vcode: vcode }
      }
      resetAuthStack(res.data?.global_logout)
    }

    if (res.type === "global_login") {
      if (res.data.global_login) {
        const isAddAccount = res.data.global_login.isAddAccount;
        const lastUid = res.data.global_login.lastUid;
        await SwitchUser(res.data.global_login, isAddAccount, lastUid);
      }
    }
  };
  const SwitchUser = async (
    auth: KKAuth,
    isAddAccount: boolean = false,
    lastUid: number = 0
  ) => {
    console.log('🔄 [App.SwitchUser] 开始切换用户, uid:', auth.uid, 'isAddAccount:', isAddAccount, 'lastUid:', lastUid);
    const r = await im.SwitchUser(auth);
    console.log('🔄 [App.SwitchUser] im.SwitchUser 返回结果:', r.error ? '失败: ' + r.error : '成功');
    if (!r.error) {
      im.GetUser(auth.uid, true).then((rsp) => {
        if (rsp.user && rsp.user.uid === auth.uid) {
          const user = rsp.user;
          const insertAuthData = {
            ...auth,
            loginType: 0,
            account: user.email,
            phone: user.telno,
            nick: user.nick,
            avatar: user.avatar,
          };
          const insertAuthResult = im.insertAuth(insertAuthData);
          if (insertAuthResult instanceof Promise) {
            insertAuthResult.then((res) => {
            }).catch((err) => {
            });
          } else {
          }
          dispatch({
            type: "UPDATE_USER_INFO",
            payload: user as any,
          });
        }
      });
      JPushManager.setAlias(auth.uid.toString());
      uploadRegistrationID();
      setVcode(auth.vcode);
      setServiceUrl(auth.customerServiceUrl);
      setUid(auth.uid);
      setToken(auth.token);
      setSecret(auth.secret);
      setEncrypt(auth.encrypt);
      setMsgAssistant(auth.msgAssistant);
      setMsgTranslate(auth.msgTranslate);
      const tenant_settings: TenantSettings = {
        switch_regist: auth.switch_regist ?? 0,
        switch_tab_main: auth.switch_tab_main ?? 0,
        switch_tab_mine: auth.switch_tab_mine ?? 1, // 至少开启一个
        switch_rtc: auth.switch_rtc ?? 0
      }
      dispatch({
        type: 'UPDATE_TENANT_SETTINGS',
        payload: tenant_settings
      });
      im.on("auth_fail", userCallback);
      // setPage({page: "main"});
      // navigation.replace('MainStack')
      navigation.reset({ index: 0, routes: [{ name: "MainStack" }] });
      regEvent();
      refreshFunc();
      refreshContact();

      attachConfig().then((res) => {
        if (res.code !== 0) {
          return;
        }

        if (res.data) {
          ImSdk.getInstance().setMediaLimitConfig(res.data);
        }
      });
    } else {
      log.warn("切换用户失败:", auth);
      im.global_emit("global_logout", {});
    }
  };

  const GetCacheTopic = (uid: number) => {
    AsyncStorage.getItem(`${uid}_topic_list`).then((res) => {
      if (res) {
        const obj = JSON.parse(res);
        const payload = obj as {
          top: TopicWithSummary[];
          normal: TopicWithSummary[];
        };
        topics.current = payload;
        if (payload) {
          // 这里检查cache是万一打开还没来得及渲染到下面后台写入 cache没值写空可就不好了
          // 同时检查下cache如果已经有最新数据了就不更新
          if (!im.GetCache(`${uid}_topic_list`)) {
            im.SetCache(`${uid}_topic_list`, payload);
          }
          const topCnt = payload.top.length;
          const normalCnt = payload.normal.length;
          log.info("====缓存命中topic_list", topCnt, normalCnt);
          dispatch({
            type: "REPLACE_TOPIC_SUMMARY_LIST",
            payload: payload,
          });
        }
      }
    });
  };

  const uploadRegistrationID = () => {
    JPushManager.getRegistrationID()
      .then((registrationID) => {
        if (!registrationID) {
          return;
        }
        reportRegistrationID({ op: 0, registration_id: registrationID }).then(
          (r) => {}
        );
      })
      .catch(() => {});
  };
  // 对于 web，createNativeStackNavigator 应该也能工作，但如果有问题可以改用 createStackNavigator
  // 如果遇到问题，需要安装: npm install @react-navigation/stack
  const RootStack = createNativeStackNavigator();

  console.log("📱 [AppContent] 准备渲染导航器, Platform.OS:", Platform.OS);

  // 在 web 上，animation 选项可能不支持 'ios'，使用 'default' 或移除
  const screenOptions =
    Platform.OS === "web"
      ? { headerShown: false }
      : { headerShown: false, animation: "ios" as const };

  return (
    <RootStack.Navigator
      screenOptions={screenOptions}
      initialRouteName="SplashStack"
    >
      <RootStack.Screen name="SplashStack" component={SplashScreen} />
      <RootStack.Screen name="MainStack" component={MainRootStack} />
      <RootStack.Screen name="AuthStack" component={AuthStack} />
    </RootStack.Navigator>
  );
}

// 外层组件：只包含 RootStack.Navigator（NavigationContainer 和 UserProvider 在 Providers.tsx 中）
function App(): React.JSX.Element {
  console.log("📱 [App] App 组件开始渲染...");

  return <AppContent />;
}

export default App;
